class AlgoliaIconRadio extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      iconSize: this.getAttribute('icon-size')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {HTMLElement} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .icon-radio,
      input[type="radio"] {
        cursor: pointer;
        display: inline-block;
        height: ${this.settings.iconSize}px;
        width: ${this.settings.iconSize}px;
      }

      input[type="radio"] {
        position: absolute;
        opacity: 0;
      }

      .icon-radio-checked,
      .icon-radio-unchecked {
        display: none;
      }

      input[type="radio"]:checked ~ span .icon-radio-checked,
      input[type="radio"]:not(:checked) ~ span .icon-radio-unchecked {
        display: inline-block;
      }
    `

    style.appendChild(document.createTextNode(css));

    return style;
  }

  /**
   * Renders the icon content.
   * @returns {HTMLElement[]} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const iconRadioChecked = this.querySelector('algolia-icon-radio-checked');
    const iconRadioUnchecked = this.querySelector('algolia-icon-radio-unchecked');
    const iconRadioCheckedContent = iconRadioChecked ? iconRadioChecked.render() : [];
    const iconRadioUncheckedContent = iconRadioUnchecked ? iconRadioUnchecked.render() : [];

    const span = document.createElement('span');
    span.classList.add('icon', 'icon-radio');

    iconRadioCheckedContent.forEach((element) => {
      span.appendChild(element);
    });


    iconRadioUncheckedContent.forEach((element) => {
      span.appendChild(element);
    });

    return [style, span];
  }
}

customElements.define("algolia-icon-radio", AlgoliaIconRadio);